export const GET_LIST_MENUS = '/menu/list';
export const GET_ALL_MENUS = '/menu/getAll';
export const GET_MENU_INFO = '/menu/getById';
export const CREATE_MENU = '/menu/create';
export const UPDATE_MENU = '/menu/update';
export const DELETE_MENU = '/menu/delete';
